module.exports = __webpack_public_path__ + "static/img/landing_bg.cda5ce05.jpg";